import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React from 'react';

interface VizSimTagChipProps {
  tag: string;
  kind?: 'class' | 'class-name' | 'tag';
  onRemove?: () => void;
  removeLabel?: string;
}

export const VizSimTagChip: React.FC<VizSimTagChipProps> = ({
  tag,
  kind = 'tag',
  onRemove,
  removeLabel,
}) => {
  const chip = (
    <>
      <span>{tag}</span>
      {onRemove ? <CloseOutlinedIcon aria-hidden="true" /> : null}
    </>
  );

  if (onRemove) {
    return (
      <button
        type="button"
        className={`vizsim-tag-chip vizsim-tag-chip--${kind} vizsim-tag-chip--editable`}
        aria-label={removeLabel ?? `Remove ${tag}`}
        onClick={onRemove}
      >
        {chip}
      </button>
    );
  }

  return (
    <span className={`vizsim-tag-chip vizsim-tag-chip--${kind}`} title={tag}>
      {chip}
    </span>
  );
};
